<template>
<div>
  <div class="horizontal">
    <div class="left">氏名</div>
    <div class="right">{{ item.data.name }}</div>
  </div>
  <div class="horizontal"
    v-if="item.data.gender">
    <div class="left">性別</div>
    <div class="right"
      v-if="item.data.gender.kind === 'custom'">{{ item.data.gender.customText }}</div>
    <div class="right"
      v-else-if="item.data.gender.kind">{{ $planConfig.genderList[item.data.gender.kind] }}</div>
    <div class="right"
      v-else>未設定</div>
  </div>
  <div class="horizontal">
    <div class="left">生年月日</div>
    <div class="right">{{ $planConfig.dateIntFormat(item.data.dateOfBirth) }}（満 {{$planConfig.calcAge(item.data.dateOfBirth)}}歳）</div>
  </div>
  <div class="horizontal">
    <div class="left">現住所</div>
    <div class="right">{{ item.data.address.postalCode }}<br>{{ item.data.address.postalDetail }}</div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
</div>
</template>

<script>
import expertComment from '@/components/parts/ExpertComment'
export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
